import * as yup from "yup";

export const options = [
  {
    id: 1,
    code: "groups",
    name: "groups",
    description_lang_key: "groups",
    permission: "employeeAccounting.curriculum.group.get",
    path: "/editor/cep/groups/",
  },
  {
    id: 2,
    code: "levels",
    name: "levels",
    description_lang_key: "levels",
    permission: "employeeAccounting.curriculum.level.get",
    path: "/editor/cep/levels/",
  },
  {
    id: 3,
    code: "courses",
    name: "courses",
    description_lang_key: "courses",
    permission: "employeeAccounting.curriculum.course.get",
    path: "/editor/cep/courses/",
  },
  {
    id: 4,
    code: "patp",
    name: "positionsAndTrainingPrograms",
    description_lang_key: "patp",
    permission: "employeeAccounting.curriculum.program.get",
    path: "/editor/cep/ptp/",
  },
];

export const coursesTableHeader = [
  "code",
  "codeIS",
  "name",
  "status",
  "levelId",
  "certificateValidityPeriod",
  "createdAt",
  "updatedAt",
];

export const groupsTableHeader = [
  "sequenceNumber",
  "name",
  "status",
  "dateActiveStatus",
  "dateInactiveStatus",
];
export const levelsTableHeader = [
  "sequenceNumber",
  "name",
  "groupName",
  "status",
  "dateActiveStatus",
  "dateInactiveStatus",
  "createdAt",
  "updatedAt",
];

export const optionsStatus = [
  { value: "inactive", label: "Неактивный" },
  { value: "active", label: "Активный" },
];

export const positionsAndTrainingProgramsTableHeader = ["code", "names"];

export const nameStatusSchemaShape = {
  name: yup.string().required("Поле обязательно для заполнения"),
  status: yup.object().shape({
    label: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
    value: yup
      .string()
      .required("Поле обязательно для заполнения")
      .notOneOf([""], "Поле не может быть пустым"),
  }),
};
